// * https://date-fns.org/v2.12.0/docs/I18n
// * https://date-fns.org/v2.12.0/docs/format

import format from 'date-fns/format'
import { zhTW } from 'date-fns/locale'

export function formatDate(date: Date, formatStr = 'PP'): string {
  try {
    return format(date, formatStr, { locale: zhTW })
  } catch (err) {
    return ''
  }
}

// * e.g. Asia/Taipei
// * see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
export function getTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

// * format to 2020-03-28T15:59:59.000Z
export function formateUTCDate(date: Date): string {
  return date.toISOString()
}
